import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CreateMilestoneRequest,
  CreateMilestoneResponse,
  DeleteMilestoneRequest,
  DeleteMilestoneResponse,
  GetAllMilestonesRequest,
  GetAllMilestonesResponse,
  GetAllBaseMilestonesRequest,
  GetAllBaseMilestonesResponse,
  UpdateMilestoneRequest,
  UpdateMilestoneResponse,
  UpdateMilestonePositionIdxRequest,
  UpdateMilestonePositionIdxResponse,
} from "../../models/Milestones.model";
import { environment } from "../../environments";

const API_BASE_URL = environment.apiUrl;

// קבלת כל אבני הדרך
export const getAllMilestones = createAsyncThunk<
  GetAllMilestonesResponse,
  GetAllMilestonesRequest,
  { rejectValue: string }
>("milestones/getAllMilestones", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Milestones/GetAllMilestones`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetAllMilestonesResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch milestones");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

// קבלת כל אבני הדרך הבסיסיות (עבור הגדרות)
export const getAllBaseMilestones = createAsyncThunk<
  GetAllBaseMilestonesResponse,
  GetAllBaseMilestonesRequest,
  { rejectValue: string }
>(
  "milestones/getAllBaseMilestones",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}Milestones/GetAllBaseMilestones`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GetAllBaseMilestonesResponse = await response.json();

      if (!data.success)
        return rejectWithValue(
          data.message || "Failed to fetch base milestones"
        );
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);

export const createOrUpdeteMilestone = createAsyncThunk<
  CreateMilestoneResponse,
  CreateMilestoneRequest,
  { rejectValue: string }
>(
  "milestones/createOrUpdeteMilestone",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}Milestones/CreateOrUpdeteMilestone`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: CreateMilestoneResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to update milestone");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);

// עדכון אבן דרך
export const updateMilestone = createAsyncThunk<
  UpdateMilestoneResponse,
  UpdateMilestoneRequest,
  { rejectValue: string }
>("milestones/updateMilestone", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Milestones/UpdateMilestone`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: UpdateMilestoneResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to update milestone");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

export const deleteMilestone = createAsyncThunk<
  DeleteMilestoneResponse,
  DeleteMilestoneRequest,
  { rejectValue: string }
>("milestones/deleteMilestone", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Milestones/DeleteMilestone`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: DeleteMilestoneResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to update milestone");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

// ✅ הוסף thunk חדש לעדכון מיקום
export const updateMilestonePositionIdx = createAsyncThunk<
  UpdateMilestonePositionIdxResponse,
  UpdateMilestonePositionIdxRequest,
  { rejectValue: string }
>(
  "milestones/updateMilestonePositionIdx",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}Milestones/UpdateMilestonePositionIdx`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: UpdateMilestonePositionIdxResponse = await response.json();

      if (!data.success)
        return rejectWithValue(
          data.message || "Failed to update milestone position"
        );
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);
